<section class="billing-return" dir="rtl">
  <div class="inner">
    <div class="spinner-border text-primary mb-3" role="status" aria-hidden="true"></div>
    <p class="mb-0">{{ message }}</p>
  </div>
</section>
